import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { ProtectedRoute } from 'components/Shared';
import {
  BlockedProductsPage,
  RedirectedProductsPage,
  PrioritizedProductsPage,
  ServiceOrdersPage,
  ImportDataPage,
  ServiceOrderDetailPage,
} from 'pages/stock-inspection';

export const stockInspectionRoutes = ({
                                        location,
                                      }: RouterProps): RouteObject => {
  const allowed = true;

  return {
    path: 'inspecao-estoque',
    element: allowed ? <Outlet /> : <Navigate to="/" state={{ from: location }} />,
    children: [
      { path: 'produtos-bloqueados', element: <BlockedProductsPage /> },
      { path: 'produtos-redirecionados', element: <RedirectedProductsPage /> },
      { path: 'produtos-priorizados', element: <PrioritizedProductsPage /> },
      { path: 'ordens-servico', element: <ServiceOrdersPage /> },
      {
        path: 'importar-planilhas',
        element: (
          <ProtectedRoute
            blockedRoles={['warehouseMember', 'planner']}
            redirectTo="/inspecao-estoque/produtos-bloqueados"
          >
            <ImportDataPage />
          </ProtectedRoute>
        )
      },
      { path: 'ordem-servico/:id', element: <ServiceOrderDetailPage /> },
    ],
  };
};